// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LinkingModal } from '@its-svp/svp-common-ui';
import * as steps from '../../constants/createDSAWorkflowSteps';
import CreateDSAWorkflowCustomerConfirmationModal from './CreateDSAWorkflowCustomerConfirmationModal';
import CreateDSAWorkflowConversionConfirmationModal from './CreateDSAWorkflowConversionConfirmationModal';
import CreateDSAWorkflowTypeSelectionModal from './CreateDSAWorkflowTypeSelectionModal';
import { getDSAWorkflowSubmitButtonLabel, getDSAWorkflowSubmitButtonLoadingLabel } from '../../utils/createDSAWorkflowHelpers';
// css
import '../../styles/components/account/CreateDSAWorkflow.scss';


class CreateDSAWorkflow extends Component {
  constructor(props) {
    super(props);
    this.toBeLinkedOpportunities = [];
    this.setOpportunities = this.setOpportunities.bind(this);
  }

  setOpportunities(toBeLinkedOpps) {
    this.toBeLinkedOpportunities = toBeLinkedOpps;
  }

  render() {
    const {
      dsa,
      step,
      account,
      open,
      clone,
      convert,
      convertCustomer,
      loading,
      onDismiss,
      onCreateCustomerDSA,
      onCreateTestDSA,
      onConfirmBeginConvertDSAWorkflow,
      onDenyCustomer,
      onConfirmBeginConvertCustomerDSAWorkflow,
      onSubmitLinkedOpportunities,
      opportunities
    } = this.props;

    if (step === steps.CONFIRM_CONVERSION) {
      return (
        <CreateDSAWorkflowConversionConfirmationModal
          open={open}
          onCancel={onDismiss}
          onConfirm={onConfirmBeginConvertDSAWorkflow}
        />
      );
    }

    if (step === steps.SELECT_LINKED_OPPORTUNITIES) {

      let linkingModalButtonLabel = null;
      if (loading) {
        linkingModalButtonLabel = getDSAWorkflowSubmitButtonLoadingLabel({ clone, convert, convertCustomer });
      } else {
        linkingModalButtonLabel = getDSAWorkflowSubmitButtonLabel({ dsa, clone, convert, convertCustomer });
      }
      return (
        <div className='svp-common-ui'>
          <LinkingModal
            open={open}
            onClose={onDismiss}
            opportunities={opportunities}
            createButtonLabel={linkingModalButtonLabel}
            accountSfid={account.sfid}
            isClone={clone}
            isConvert={convertCustomer}
            onSubmit={() => onSubmitLinkedOpportunities(this.toBeLinkedOpportunities)}
            onTrainingAssessmentClick={onCreateTestDSA}
            setOpportunitiesToLink={(toBeLinkedOpps) => this.setOpportunities(toBeLinkedOpps)}
          />
        </div>
      );
    }

    if (step === steps.CONFIRM_CUSTOMER_CONVERSION) {
      return (
        <CreateDSAWorkflowCustomerConfirmationModal
          open={open}
          onDismiss={onDismiss}
          onDeny={onDenyCustomer}
          onConfirm={onConfirmBeginConvertCustomerDSAWorkflow}
        />
      );
    }

    return (
      <CreateDSAWorkflowTypeSelectionModal
        account={account}
        clone={clone}
        convert={convert}
        open={open}
        loading={loading}
        onDismiss={onDismiss}
        onCreateCustomerDSA={onCreateCustomerDSA}
        onCreateTestDSA={onCreateTestDSA}
      />
    );
  }
}

CreateDSAWorkflow.propTypes = {
  step: PropTypes.string,
  dsa: PropTypes.object,
  account: PropTypes.object,
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onCreateCustomerDSA: PropTypes.func.isRequired,
  onCreateTestDSA: PropTypes.func.isRequired,
  onSubmitLinkedOpportunities: PropTypes.func.isRequired,
  clone: PropTypes.bool,
  convert: PropTypes.bool,
  convertCustomer: PropTypes.bool,
  onConfirmBeginConvertDSAWorkflow: PropTypes.func.isRequired,
  onDenyCustomer: PropTypes.func.isRequired,
  onConfirmBeginConvertCustomerDSAWorkflow: PropTypes.func.isRequired,
  opportunities: PropTypes.object
};

export default CreateDSAWorkflow;



// WEBPACK FOOTER //
// ./src/components/account/CreateDSAWorkflow.js